import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Bounce, ToastContainer, toast } from 'react-toastify';
import Header from '~/componentsPage/Header/Header';
import styles from '~/styles/PageNotFound/PageNotFound.module.css';

type Status = 'loading' | 'success' | 'error';

function Activate() {
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<Status>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Brak tokena aktywacyjnego w adresie URL.');
      return;
    }

    fetch(`/api/auth/activate/${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === 200) {
          toast.success('Konto zostało pomyślnie aktywowane!', {
            position: 'top-center',
            autoClose: 6000,
            transition: Bounce,
          });
          const pending = sessionStorage.getItem('pendingActivationLogin');
          if (pending) {
            sessionStorage.removeItem('pendingActivationLogin');
            sessionStorage.setItem('activationComplete', pending);
          } else {
            sessionStorage.setItem('activationComplete', JSON.stringify({}));
          }
          setStatus('success');
          setMessage(data.message || 'Konto zostało pomyślnie aktywowane!');
        } else {
          setStatus('error');
          setMessage(data.message || 'Wystąpił błąd podczas aktywacji konta.');
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Wystąpił błąd połączenia z serwerem. Spróbuj ponownie później.');
      });
  }, [token]);

  return (
    <div className={styles.pageContainer}>
      <ToastContainer />
      <Header />

      <main className={styles.contactContent}>
        <div
          className={styles.contactCard}
          style={{ padding: '80px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}
        >
          {status === 'loading' && (
            <>
              <div style={{ fontSize: '3rem' }}>⏳</div>
              <h1 style={{ fontSize: '1.8rem', margin: '0' }}>Trwa aktywacja konta...</h1>
              <p style={{ color: 'var(--text-muted)', margin: '0' }}>
                Prosimy czekać, weryfikujemy Twój link aktywacyjny.
              </p>
            </>
          )}

          {status === 'success' && (
            <>
              <div style={{ fontSize: '4rem' }}>✅</div>
              <h1 style={{ fontSize: '2rem', margin: '0', color: 'var(--accent-color)' }}>
                Konto aktywowane!
              </h1>
              <p style={{ maxWidth: '400px', margin: '0 auto', color: 'var(--text-muted)', textAlign: 'center' }}>
                {message}
              </p>
              <Link
                to="/"
                className={styles.socialBtn}
                style={{ background: 'var(--accent-color)', color: 'white', padding: '15px 40px', fontSize: '1.1rem', marginTop: '10px' }}
              >
                Przejdź do logowania
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <div style={{ fontSize: '4rem' }}>❌</div>
              <h1 style={{ fontSize: '2rem', margin: '0' }}>Błąd aktywacji</h1>
              <p style={{ maxWidth: '400px', margin: '0 auto', color: 'var(--text-muted)', textAlign: 'center' }}>
                {message}
              </p>
              <Link
                to="/"
                className={styles.socialBtn}
                style={{ background: 'var(--accent-color)', color: 'white', padding: '15px 40px', fontSize: '1.1rem', marginTop: '10px' }}
              >
                Wróć na stronę główną
              </Link>
            </>
          )}
        </div>
      </main>

      <footer className={styles.mainFooter}>
        <div className={styles.footerContent}>
          <div className={styles.footerLinks}>
            <Link to="/pomoc">Pomoc</Link>
            <Link to="/kontakt">Kontakt</Link>
            <Link to="/polityka-prywatnosci">Polityka prywatności</Link>
            <Link to="/regulamin">Regulamin</Link>
          </div>
          <div className={styles.copyright}>© 2026 Czateria24. Wszystkie prawa zastrzeżone.</div>
        </div>
      </footer>
    </div>
  );
}

export default Activate;
